"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Phone = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/20-Phones-Mobile-Devices/01-Phone/Phone"));
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _Navigation = _interopRequireDefault(require("../../Navigation"));
var _formatTelHref = _interopRequireDefault(require("@berlitz/max-utils/lib/formatTelHref"));
var _TopNav = require("../../TopNav.style");
var _LanguageDropDown = _interopRequireDefault(require("./LanguageDropDown"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var DesktopNav = function DesktopNav(props) {
  var dataKey = props.isSticky ? 'max-header--sticky' : 'max-header';
  var phoneNumberClean = (0, _formatTelHref.default)(props.telNumber);
  return /*#__PURE__*/_react.default.createElement(_TopNav.Wrapper, {
    "aria-hidden": props.isSticky ? 'true' : 'false',
    className: props.isSticky && 'desktop-sticky-nav',
    "data-key": dataKey,
    isSticky: props.isSticky,
    stickyNavActive: props.stickyNavActive,
    visibilityHidden: !props.isSticky && props.stickyNavActive
  }, !props.isSticky && /*#__PURE__*/_react.default.createElement(_TopNav.Container, {
    "aria-label": "Secondary Navigation",
    "data-key": "".concat(dataKey, "__top-bar")
  }, props.secondaryLinks && /*#__PURE__*/_react.default.createElement(_TopNav.Column, {
    "data-key": "".concat(dataKey, "__top-bar__left"),
    "aria-label": "Secondary Navigation Menu"
  }, props.secondaryLinks.map(function (link, index) {
    return /*#__PURE__*/_react.default.createElement(_TopNav.NavListItem, {
      isDark: props.isSticky || props.isDark,
      "data-key": "".concat(dataKey, "__left-column__link-").concat(index),
      key: "".concat(dataKey, "__left-column__link-").concat(index),
      small: true,
      onFocus: function onFocus() {
        return props.closeDropDown();
      }
    }, link);
  })), props.topRightComponents, Array.isArray(props.languageLinks) && /*#__PURE__*/_react.default.createElement(_LanguageDropDown.default, {
    languageLinks: props.languageLinks,
    isDark: props.isDark,
    activeDropDown: props.activeDropDown,
    activeLanguage: props.activeLanguage,
    handleDropDownFocus: props.handleDropDownFocus
  })), /*#__PURE__*/_react.default.createElement(_TopNav.Container, {
    "aria-label": "Primary Navigation",
    "data-key": "".concat(dataKey, "-navigation")
  }, /*#__PURE__*/_react.default.createElement(_TopNav.LogoWrapper, {
    "data-key": "".concat(dataKey, "-navigation__logo"),
    onFocus: function onFocus() {
      return props.closeDropDown();
    }
  }, props.logo), /*#__PURE__*/_react.default.createElement(_TopNav.NavigationWrapper, null, /*#__PURE__*/_react.default.createElement(_Navigation.default, {
    isSticky: props.isSticky,
    primaryLinks: props.primaryLinks,
    isDark: props.isSticky || props.isDark,
    "data-key": "".concat(dataKey, "-desktop-navigation__nav"),
    "aria-label": "Primary Navigation Menu",
    handleDropDownFocus: props.handleDropDownFocus,
    moreText: props.moreText,
    priorityNumber: props.isSticky && props.telNumber ? props.priorityNumber - 1 : props.priorityNumber,
    activeDropDown: props.activeDropDown,
    closeDropDown: props.closeDropDown
  }), props.isSticky && props.telNumber && /*#__PURE__*/_react.default.createElement(_TopNav.StickyNavPhoneLink, {
    "data-key": "".concat(dataKey, "__tel-icon"),
    href: "".concat(phoneNumberClean)
  }, /*#__PURE__*/_react.default.createElement(_Phone.default, {
    title: "Click to call"
  }), /*#__PURE__*/_react.default.createElement(_TopNav.PhoneNumber, null, props.telNumber)), props.isSticky && props.stickyNavCta && /*#__PURE__*/_react.default.createElement(_spacer.default, {
    size: "xs",
    left: true,
    "data-key": "".concat(dataKey, "__cta")
  }, props.stickyNavCta))));
};
var _default = DesktopNav;
exports.default = _default;